<template>
  <v-container fluid>
    <!-- TABS -->
    <div
        v-if="isTabHorizontal && dashboardsLen > 1"
    >
      <v-tabs 
        right
        height="28px"
        v-model="tabs"
      >
        <v-tab 
          v-for="dboard in dashboards" 
          :key="`dashboard_${dboard.id}`"
        > {{ dboard.title }} </v-tab>
      </v-tabs>
    </div>

    <!-- Canvas -->
    <v-row no-gutters>
      <v-col>
        <div
          class="canvas"
          :class="{active: templateEdit}"
          id="canvas-wrap"
          ref="canvasWrap"
          @contextmenu.self="showMenu"
          :style="{backgroundColor: canvasBg, minHeight: canvasHeight}"
        >
          <canvas id="demo-canvas"></canvas>
        
          <span v-if="dashboard && dashboard.widgets && dashboard.widgets.length > 0">
            <WidgetWrap
              v-for="widget in dashboard.widgets"
              :key="widget.id"
              :options="widget"
              :editable="templateEdit"
              @change:openEdit="openEdit(widget.id)"
            >
              <component
                :is="widget.type"
                :view="widget.currentView"
                :widget="widget"
              />
            </WidgetWrap>
          </span>
          <span
            v-if="templateEdit"
            class="invisible_dot"
            :style="{top: `${invisiblePosition}px`}"
          />
        </div>
      </v-col>
      <!-- TABS -->
      <v-col 
        v-if="!isTabHorizontal && dashboardsLen > 1"
        cols="auto" 
        class="background"
      >
        <v-tabs
          vertical
          v-model="tabs"
        >
          <v-tab
            v-for="dboard in dashboards"
            :key="`dashboard_${dboard.id}`"
          > {{ dboard.title }} </v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <div 
      v-if="templateEdit"
      class="expand_canvas mt-1 ml-n1 text-center"
      :style="{width: expandWidth}"
      role="button"
      title="При нажатии увеличивается высота Дашборда"
      @click="expandCanvas"
    >
      <v-icon >mdi-arrow-expand-down</v-icon>
    </div>

    <!-- Модалки создания/удаления ДАШБОРДА -->
    <CreateDashboard 
      v-if="isCreateDashboard" 
      v-model="isCreateDashboard" 
      @created="dashboardCreated"
    />
    <DeleteDashboard v-if="isDeleteDashboard" v-model="isDeleteDashboard" />
    <!-- Модалки создания/редактирования ВИДЖЕТОВ -->
    <CreateWidget v-if="isCreate" v-model="isCreate" :position="rbmMenu" />
    <EditWidget v-if="isEdit" v-model="isEdit" :widgetId="widgetId" />

    <ShareDashboard v-if="isShareDialog" v-model="isShareDialog" />

    <!-- Меню на прав. кнопку мыши -->
    <v-menu
      v-model="rbmMenu.show"
      :position-x="rbmMenu.x"
      :position-y="rbmMenu.y"
      absolute
      offset-y
      transition="scale-transition"
    >
      <v-list flat>
        <!-- В режиме просмотра -->
        <v-list-item-group
          v-if="!templateEdit"
          v-model="rbmMenu.value"
          color="primary"
        >
          <v-list-item 
            v-if="hasRole(['leader', 'manager', 'supervisor'])"
            @click="switchMode"
          >
            <v-icon>mdi-pencil</v-icon>
            <span class="ml-2">Режим редактирования [E]</span>
          </v-list-item>

          <v-list-item v-if="dashboards.length > 1" @click="isTabHorizontal = !isTabHorizontal">
            <v-icon>mdi-tab</v-icon>
            <span class="ml-2">Вкладки сверху/справа</span>
          </v-list-item>

        </v-list-item-group>

        <!-- В режиме редактирования -->
        <v-list-item-group
          v-else
          v-model="rbmMenu.value"
          color="primary"
        >
          <v-list-item @click="isCreate = true" >
            <v-icon>mdi-plus</v-icon>
            <span class="ml-2">Добавить виджет</span>
          </v-list-item>

          <v-list-item @click="alignWidgets">
            <v-icon>mdi-align-vertical-top</v-icon>
            <span class="ml-2">Выровнять виджеты</span>
          </v-list-item>

          <v-list-item @click="switchMode">
            <v-icon>mdi-content-save</v-icon>
            <span class="ml-2">Режим просмотра [E]</span>
          </v-list-item>


          <v-divider inset />

          <v-list-item @click="isShareDialog = true">
            <v-icon>mdi-share</v-icon>
            <span class="ml-2">Поделиться этим дашбордом</span>
          </v-list-item>

          <v-list-item @click="isCreateDashboard = true">
            <v-icon>mdi-plus</v-icon>
            <span class="ml-2">Создать дашборд</span>
          </v-list-item>

          <v-list-item v-if="dashboards.length > 1" @click="isDeleteDashboard = true">
            <v-icon>mdi-delete</v-icon>
            <span class="ml-2">Удалить дашборд</span>
          </v-list-item>

        </v-list-item-group>
      </v-list>
    </v-menu>

  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import Dashboard from './Dashboard' //TODO придумать как разнести логику нахрееен!!! :(
import WidgetWrap from './WidgetWrap'
import CreateDashboard from './modals/CreateDashboard'
import DeleteDashboard from './modals/DeleteDashboard'
import ShareDashboard from './modals/ShareDashboard'

import CreateWidget from './modals/CreateWidget'
import EditWidget from './modals/EditWidget'

import HintWidget from './widgets/HintWidget'
import TableSl from './widgets/TableSl'
import EmploymentWidget from './widgets/EmploymentWidget'
import AcceptedMissed from './widgets/AcceptedMissed'
import GroupByOperator from './widgets/GroupByOperator'
import HourlyDynamics from './widgets/HourlyDynamics'
import ExtendedCall from './widgets/ExtendedCall'
import OksReport from './widgets/OksReport'
import AvgAgentTime from './widgets/AvgAgentTime'
import TransferWidget from './widgets/TransferWidget'
import ForecastCalls from './widgets/ForecastCalls'
import OutgoingCalls from './widgets/OutgoingCalls'
import OutgoingByOperators from './widgets/OutgoingByOperators'
import StatisticByOperators from './widgets/StatisticByOperators'
import VuelinerTable from './widgets/VuelinerTable'
import StatisticByQueues from './widgets/StatisticByQueues'
import OperatorCampaignStatiscticByDays from './widgets/OperatorCampaignStatiscticByDays'
import PercentageAcceptByCampaign from './widgets/PercentageAcceptByCampaign'

// import bgAnim from '../../../bg-lib/index.js'

export default {
  name: 'DashboardPage',
  components: {
    CreateDashboard,
    DeleteDashboard,
    CreateWidget,
    EditWidget,
    WidgetWrap,
    TableSl,
    HintWidget,
    EmploymentWidget,
    AcceptedMissed,
    GroupByOperator,
    HourlyDynamics,
    ExtendedCall,
    OksReport,
    AvgAgentTime,
    TransferWidget,
    ForecastCalls,
    ShareDashboard,
    OutgoingCalls,
    OutgoingByOperators,
    StatisticByOperators,
    VuelinerTable,
    StatisticByQueues,
    OperatorCampaignStatiscticByDays,
    PercentageAcceptByCampaign,
  },
  data() {
    return {
      tabs: 0,
      templateEdit: false,
      isCreate: false,
      isEdit: false,
      widgetId: '',
      invisiblePosition: 100,
      rbmMenu: {
        value: -1,
        show: false,
        x: 0,
        y: 0,
        xW: 0,
        yW: 0,
      },

      hintOptions: {
        id: 'HintWidget_1',
        name: 'Справка',
        type: 'HintWidget',
        hint: 'Это виджет - справка',
        position: {
          x: 100,
          y: 50,
          width: 650,
          height: 400,
          min_width: 650,
          max_width: 1200,
          min_height: 200,
          max_height: 1200,
        }
      },

      isCreateDashboard: false,
      isDeleteDashboard: false,

      isShareDialog: false,
      isTabHorizontal: true,
    }
  },
  computed: {
    ...mapGetters({
      dashboards: 'dashboard/dashboards',
      dashboard: 'dashboard/dashboard',
      hasRole: 'user/hasRole',
    }),

    canvasBg() {
      if (this.$vuetify.theme.isDark) return '#151515'
      else return '#f2f2f2'
    },

    canvasHeight() {
      let h = 'calc(100vh - 125px)';
      if (!this.isTabHorizontal) h = 'calc(100vh - 100px)';
      return h
    },

    expandWidth() {
      let w = 'calc(100% + 8px)';
      if (!this.isTabHorizontal) w = 'calc(94% + 1px)';
      return w
    },

    dashboardsLen() {
      return this.dashboards.length || 0;
    },

    dashboardLS() {
      return {
        tabs: this.tabs,
        isTabHorizontal: this.isTabHorizontal
      }
    },

  },

  watch: {
    isEdit(val) {
      if (!val) this.widgetId = '';
    },

    templateEdit(val) {
      if (!val) {
        this.saveDashboard();
      } else {
        this.invisiblePosition = this.$refs.canvasWrap.scrollHeight - 1;
      }
    },

    tabs(val) {
      this.setDashboard(this.dashboards[val]);
      localStorage.setItem('dashboard', JSON.stringify(this.dashboardLS));
    },

    isTabHorizontal() {
      // Это для того чтобы канвас (задний фон красивый) подогнался под размер.
      // Да вот такие костыли, а как иначе? 8D
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 220);
      localStorage.setItem('dashboard', JSON.stringify(this.dashboardLS));
    },

    dashboardsLen(v) {
      if (v === 1) {
        if (this.tabs === 0) {
          this.setDashboard(this.dashboards[0]);
        }
        this.tabs = 0;
      }
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 1000);
    },
  },

  methods: {
    ...mapActions({
      loadDashboards: 'dashboard/loadDashboards',
      saveDashboard: 'dashboard/saveDashboard',
      setDashboard: 'dashboard/setDashboard',
      createDashboard: 'dashboard/createDashboard',

      loadAllGroups: 'graphql/loadAllGroups',
      loadAllProjects: 'graphql/loadAllProjects',
    }),

    switchMode() {
      if (this.hasRole(['leader', 'manager', 'supervisor']))
        this.templateEdit = !this.templateEdit;
    },

    showMenu(ev) {
      ev.preventDefault();
      this.rbmMenu.show = false;
      this.rbmMenu.x = ev.clientX;
      this.rbmMenu.y = ev.clientY;
      
      this.$nextTick(() => {
        this.rbmMenu.xW = ev.offsetX + ev.target.scrollLeft;
        this.rbmMenu.yW = ev.offsetY + ev.target.scrollTop;
        this.rbmMenu.show = true;
        this.rbmMenu.value = -1;
      })
    },

    openEdit(id) {
      this.widgetId = id;
      this.isEdit = true;
    },

    moveHintToCenter() {
      this.hintOptions.position.x = (this.$refs.canvasWrap.getBoundingClientRect().width / 2 - 650 / 2);
      this.hintOptions.position.height = (this.$refs.canvasWrap.getBoundingClientRect().height - 100);
    },

    expandCanvas() {
      this.invisiblePosition = this.$refs.canvasWrap.scrollHeight + 200;
      setTimeout(() => {
        this.$refs.canvasWrap.scrollTo({behavior: 'smooth', top: 99999});
      }, 100);
    },

    alignWidgets() {
      this.dashboard.widgets.forEach(w => {
        fixPos(w, 'y')
        fixPos(w, 'x')
        fixPos(w, 'width')
        fixPos(w, 'height')
      })

      function fixPos(widget, pos) {
        let r = widget.position[pos] % 10
        if (r >= 5) widget.position[pos] += 10 - r
        else widget.position[pos] -= r
      }

    },

    keyHandle() {
      window.addEventListener('keypress', ev => {
        switch (ev.key.toLowerCase()) {
          case 'e':
          case 'у':
            if (
              this.isCreateDashboard === false &&
              this.isDeleteDashboard === false &&
              this.isCreate === false &&
              this.isEdit === false &&
              this.isShareDialog === false
            ) this.switchMode();
            break;

          default:
            break;
        }
      })
    },

    dashboardCreated() {
      this.templateEdit = true;
      this.tabs = this.dashboards.length - 1;
    },
  },

  async created() {
    await this.loadAllGroups()
    await this.loadAllProjects()
  },
  
  async mounted() {
    await this.loadDashboards();
    // bgAnim();
    // OOOPS

    if (this.dashboards.length > 0) {
      this.setDashboard(this.dashboards[0]);
    }

    let ls = localStorage.getItem('dashboard');
    if (ls) {
      ls = JSON.parse(ls);
      if (this.dashboards.length > 1) this.tabs = ls.tabs;
      this.isTabHorizontal = ls.isTabHorizontal;
    }

    if (this.dashboards.length === 0) {
      let tempPayload = {
        is_private: true,
      }
      this.moveHintToCenter();
      let tempDashboard = {
        name: 'temp',
        title: 'Временный',
        widgets: [this.hintOptions],
      };
      tempPayload.content = JSON.stringify(tempDashboard);
      await this.createDashboard(tempPayload);
      await this.loadDashboards();
      this.setDashboard(this.dashboards[0]);
    }

    this.invisiblePosition = this.$refs.canvasWrap.scrollHeight - 1;

    this.keyHandle();
  },
}
</script>

<style lang="scss" scoped>
.canvas {
  position: relative;
  min-width: 100%;
  // min-height: calc(100vh - 125px);
  overflow-x: auto;

  #demo-canvas {
    pointer-events: none;
    position: fixed;
  }
  &.active {
    outline: 4px dashed #2196f394;
  }

  .invisible_dot {
    position: absolute;
    width: 1px;
    height: 1px;
    visibility: none;
    pointer-events: none;
  }
}

.expand_canvas {
	// min-width: calc(100% + 8px);
	background-color: hsla(207, 90%, 54%, 0.58);
	cursor: pointer;
	border-radius: 0 0 17px 17px;
  transition: box-shadow 180ms ease-in-out,
    background-color 100ms ease;

  &:hover {
    background-color: hsla(207, 90%, 45%, 0.58);
    box-shadow: inset 0 0 10px #212121;
  }
  &:active {
    background-color: hsla(207, 90%, 60%, 0.58);
    box-shadow: inset 0 0 10px #212121;
  }
}

</style>
